import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { HttpErrorHandler } from './http-error-handler';
import { environment } from 'environments/environment.prod';

export class Form {
  protected form: FormGroup;
  protected instance: any = {};
  protected createMode: Boolean;
  protected updateMode: Boolean;
  protected nonFieldErrors: string;
  protected formService: any;
  protected modelHandler: any;
  protected updateFlag: boolean;
  public locale_es = environment.datepickerConfig;

  constructor(protected route: ActivatedRoute, protected httpErrorHandler: HttpErrorHandler) {
    this.createMode = false;
    this.updateMode = false;
  }

  protected initialize(service: any, modelHandler) {
    this.formService = service;
    this.modelHandler = modelHandler;
  }

  setFormMode(mode) {
    switch (mode) {
      case 'create':
        this.createMode = true;
        break;
      case 'update':
        this.updateMode = true;
    }
  }

  hasNonFieldErrors() {
    if (this.nonFieldErrors !== undefined && this.nonFieldErrors !== '') {
      return true;
    } else {
      return false;
    }
  }

  resetNonFieldErrors() {
    this.nonFieldErrors = '';
  }

  parseApiErrors(errors, form) {
    this.nonFieldErrors = '';
    this.resetApiErrors(form);

    if (errors !== undefined) {
      Object.keys(errors).forEach((key) => {
        if (form.controls.hasOwnProperty(key)) {
          form.controls[key].setErrors({
            remote: errors[key],
          });
        }

        if (key === 'non_field_errors') {
          this.nonFieldErrors = errors[key];
        }
      });
    }
  }

  resetApiErrors(form) {
    this.nonFieldErrors = '';
    for (const key in form.controls) {
      if (form.controls.hasOwnProperty(key)) {
        form.controls[key].markAsPristine();
        form.controls[key].markAsUntouched();
        form.controls[key].updateValueAndValidity();
      }
    }
  }

  parseDropdownResults(results, modelHandler, label, emptyOption = true): any[] {
    const collection = [];
    // check add empty option
    if (emptyOption) {
      collection.push({ label: '', value: null });
    }

    for (let item of results) {
      item = modelHandler.apiMap(item);
      collection.push({ label: item[label], value: item });
    }
    return collection;
  }

  protected get() {
    this.route.params.forEach((params: Params) => {
      const id = +params['id'];
      this.formService.get(id).subscribe(
        (instance) => {
          this.instance = this.modelHandler.apiMap(instance);
          this.onLoad(this.instance);
        },
        (error) => this.handleError(error)
      );
    });
  }

  protected update(redirect = false) {
    this.updateFlag = true;
    this.formService.update(this.instance.serialize()).subscribe(
      (instance) => {
        this.onUpdate(instance, redirect);
        this.updateFlag = false;
      },
      (error) => this.handleError(error)
    );
  }

  protected onLoad(instance) {}

  protected onUpdate(instance, redirect) {}

  protected handleError(error) {
    this.parseApiErrors(this.httpErrorHandler.handleHttpError(error), this.form);
  }

  protected removeFromList(l: Array<any>, item: any) {
    const index = l.indexOf(item, 0);
    if (index > -1) {
      l.splice(index, 1);
    }
  }

  protected addToList(l: Array<any>, item: any) {
    if (!l.includes(item)) {
      l.push(item);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/form.ts